// var getProductClient = require('../../../../js_functions/getProductClient');

const getVisibleClientFields = require('../visible-client-fields');

// This list only needs to contain fields affected by the 'visibility' property (e.g. excluding hidden field ids).
// Property keys apply to a medication field.
// Property values dictate visibility.
// Booleans apply as-is.
// Objects are applied according to who the client is, given from the 'getProductClient' function.
// Object properties apply to a client name or 'code'.
// Object values apply as-is.
// Anything left out is falsey and therefore invisible.
var fieldVisibility = {
  columnTitleRow: true,
  columnButtonRow: true,
  drugRow: true,
  brandRow: true,
  manufacturerRow: true,
  classRow: {
    other: true
  },
  strengthRow: {
    spsc: true,
    nswh: true,
  },
  supplierRow: {
    spsc: true,
    nswh: true,
  },
  typeRow: {
    other: true
  },
  sourceIdRow: true,
  routeRow: true,
  doseRow: true,
  formRow: true,
  reportToManufacturerRow: true,
  dateReportedToManufacturer: true,
  manufacturerRef: true,
  isStillAdministered: true,
  frequency: true,
  productExpiryDate: true,
  actionTaken: true,
  adrLessened: true,
  adrReappeared: true,
  bnfClassificationRow: {
    other: true
  },
  batchNumberRow: {
    other: true
  },
  ethicsCommitteeNameReferenceRow: {
    other: true
  },
  clinicalTrialRow: {
    other: true
  },
  manufacturedSpecialRow: {
    other: true
  },
  parallelImport: {
    other: true
  },
  stageErrorOccurredRow: {
    other: true
  },
  stageErrorOccurred: {
    other: true
  },
  typeOfErrorRow: {
    other: true
  },
  typeOfError: {
    other: true
  },
  notes: {
    other: true
  },
  importantFactorsRow: {
    other: true
  },
  importantFactors: {
    other: true
  },
  dateFirstUsedRow: true,
  dateLastUsedRow: true,
  adrDateReactionStarted: false,
  adrDateReactionStopped: false,
  frequencyWrong: false,
  drugReaction: false,
  errorDetectedBy: false,
  errorCommittedBy: false,
  didDrugReactionReappear: false,
  adrOrganSystem: false,
  naranjoTotalScore: false,
  adrActionTaken: false,
  editBottomRow: true,
};

function getVisibleClientFieldsWrapper() {
  return getVisibleClientFields(fieldVisibility);
}

module.exports = getVisibleClientFieldsWrapper;
